






















import {Component, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {AddressBookFilter} from "@/store/addressbooks/types";
import FilterSelectedItemWings from "@/components/Filter/FilterSelectedItemWings.vue";
import {FilterWings, SelectWings} from "@/components";
import {notifyError} from "@/utils/notify-helper";

@Component({components: {FilterSelectedItemWings, SelectWings, FilterWings}})
export default class AddressBooksFilter extends BaseFilter<AddressBookFilter> {
  @PropSync('show') is_show!: boolean;
  @Action("getAddressBooks") actionGetAddressBooks: any;

  defaultFilter(): AddressBookFilter {
    return {
      name: undefined,
    };
  }

  created() {
    this.filtered();
  }

  onFilteredAction(): void {
    try {
      this.actionGetAddressBooks(this.filter);
    } catch(error) {
      notifyError(error);
    }
  }

}
